import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import PropTypes from 'prop-types';
import React from 'react';
import PrimaryButton from '../core/PrimaryButton';
import SecondaryButton from '../core/SecondaryButton';
import { globalStyles } from '../core/style/gstheme';
import StatementData from './StatementData';

const styles = Object.assign({}, globalStyles);

class ReificationDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            statementIndex: 0
        };
    }

    handlePrev = (index) => this.setState({ statementIndex: index - 1 });

    handleNext = (index) => this.setState({ statementIndex: index + 1 });

    render() {

        const { isReadOnly, defaultLang, projectLang, linkedData, ontologyProjectAssociation, dialogComponent,
            viewLang, graph, classes, propertyTemplates, projectType, property, requiredEntitlement,
            projectIRI, componentIRI, useWorkflow, associatedTaxonomyProject, showDialog, subject, value,
            components, statements } = this.props;

        const { statementIndex } = this.state;

        const statement = statements[statementIndex];

        return (
            <Dialog
                data-test="reification-dialog"
                maxWidth="xl"
                fullScreen
                className={classes.dialog}
                classes={{
                    paper: classes.paper,
                    paperWidthXl: classes.xLargeDialog
                }}
                open={true}
                onClose={() => showDialog(false)}
                aria-labelledby="reify-dialog-title">
                <DialogTitle disableTypography className={classes.mainHeading} id="reify-dialog-title">Annotation Detail</DialogTitle>
                <DialogContent>
                    {statements.length > 1 &&
                        <div style={{ textAlign: 'center' }}>
                            <span style={{ marginRight: 24 }}>
                                <SecondaryButton
                                    dataTest="prev-statement"
                                    disabled={statementIndex === 0}
                                    onClick={() => this.handlePrev(statementIndex)}
                                    startIcon={<ArrowBackIcon />}>Previous Statement</SecondaryButton>
                            </span>
                            <span>
                                <SecondaryButton
                                    dataTest="next-statement"
                                    disabled={statementIndex === statements.length - 1}
                                    onClick={() => this.handleNext(statementIndex)}
                                    endIcon={<ArrowForwardIcon />}>
                                    <span>Next Statement&#160;</span>
                                    {statementIndex < statements.length - 1 &&
                                        <span data-test="statement-count">({statementIndex + 2} of {statements.length})</span>
                                    }
                                </SecondaryButton>
                            </span>
                        </div>
                    }
                    <StatementData
                        subject={subject}
                        dialogComponent={dialogComponent}
                        property={property}
                        value={value}
                        statements={statements}
                        id={statement.id}
                        key={statement.id}
                        requiredEntitlement={requiredEntitlement}
                        ontologyProjectAssociation={ontologyProjectAssociation}
                        graph={graph}
                        showDialog={showDialog}
                        projectIRI={projectIRI}
                        componentIRI={componentIRI}
                        useWorkflow={useWorkflow}
                        propertyTemplates={propertyTemplates}
                        isReadOnly={isReadOnly}
                        viewLang={viewLang}
                        projectLang={projectLang}
                        projectType={projectType}
                        linkedData={linkedData}
                        associatedTaxonomyProject={associatedTaxonomyProject}
                        components={components}
                        defaultLang={defaultLang} />
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <PrimaryButton dataTest="close-reification-dialog" onClick={() => showDialog(false)} >Close</PrimaryButton>
                </DialogActions>
            </Dialog>
        );
    }
}

ReificationDialog.defaultProps = {
    statements: [],
    isReadOnly: false
};

ReificationDialog.propTypes = {
    requiredEntitlement: PropTypes.string.isRequired,
    projectIRI: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    associatedTaxonomyProject: PropTypes.array,
    showDialog: PropTypes.func,
    statements: PropTypes.array,
    componentIRI: PropTypes.string,
    isReadOnly: PropTypes.bool,
    classes: PropTypes.object
};

export default withStyles(styles)(ReificationDialog);